import destinationGroups from './destination-groups.json';

export default {
  destinationGroups,
};
